import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon6",
  "use": "icon6-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon6\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h32v32H0z\" /><path d=\"M29.064 4.753a1 1 0 011 1v20.5a1 1 0 01-1 1H2.939a1 1 0 01-1-1v-20.5a1 1 0 011-1h26.125zm-2.752 3.75H5.688v11.755l5.384-5.465 4.559 3.02 3.76-3.912-1.69-1.458 5.801-1.13-.744 5.519-1.662-1.754-4.271 7.158-4.631-3.08-2.324 4.347h16.444v-15z\" fill=\"#00D48A\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol